import { InvoiceSortingColumn } from 'anchor-scout-common/types';
import { AccountingStatusFilter } from '~/business-logic/qboStatusFilterLogic';
// The new /invoices endpoint accepts only Synced/NotSynced for sync filters.
// Pending/Failed are dropped because the new endpoint does not support them.
export function externalSyncFilter(value) {
    return value === AccountingStatusFilter.Synced || value === AccountingStatusFilter.NotSynced ? value : undefined;
}
// The new /invoices endpoint exposes a single `displayStatus` sort key in place of the legacy
// Status / DisplayStatusV2 split.
export function externalSortField(field) {
    switch(field){
        case InvoiceSortingColumn.Number:
        case InvoiceSortingColumn.CompanyName:
        case InvoiceSortingColumn.IssuedOn:
        case InvoiceSortingColumn.DueDate:
        case InvoiceSortingColumn.TotalAmount:
            return field;
        case InvoiceSortingColumn.Status:
        case InvoiceSortingColumn.DisplayStatusV2:
            return 'displayStatus';
        case undefined:
        default:
            return undefined;
    }
}
